import ability from '@contexts/ability/Ability';
import { AbilityContext } from '@contexts/ability/Can';

export function AbilityProvider({ children }) {
  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}

export { AbilityContext as default } from '@contexts/ability/Can';
